module.exports = __webpack_public_path__ + "img/IMG_8981_L.025ed0e4.webp";